var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseCircleFilled = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM7.5757 7.57572C7.81002 7.34141 8.18992 7.34141 8.42423 7.57572L9.99997 9.15146L11.5757 7.57574C11.81 7.34142 12.1899 7.34142 12.4242 7.57574C12.6585 7.81005 12.6585 8.18995 12.4242 8.42426L10.8485 9.99999L12.4242 11.5757C12.6585 11.81 12.6585 12.1899 12.4242 12.4242C12.1899 12.6585 11.81 12.6585 11.5757 12.4242L9.99997 10.8485L8.42425 12.4242C8.18993 12.6586 7.81003 12.6586 7.57572 12.4242C7.3414 12.1899 7.3414 11.81 7.57572 11.5757L9.15145 9.99999L7.5757 8.42425C7.34139 8.18993 7.34139 7.81003 7.5757 7.57572Z",
    fill: "#868381"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseCircleFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CloseCircleFilled.ea6b826c.svg";
export { ForwardRef as ReactComponent };